{
  "header": {
    "title": "Enkätmallar",
    "description": "Bläddra bland och anpassa färdiga enkätmallar för att snabbt samla in värdefulla insikter från medarbetare"
  },
  "tabs": {
    "chirpeeTemplates": "Chirpee-mallar",
    "companyTemplates": "Företagsmallar",
    "myTemplates": "Mina mallar"
  },
  "searchInput": {
    "placeholder": "Sök mallar"
  },
  "sortDropdown": {
    "triggerLabel": "Sortera efter",
    "options": {
      "questionQuantity": "Antal frågor",
      "fromNewestToOldest": "Från nyast till äldst",
      "fromOldestToNewest": "Från äldst till nyast"
    }
  }
}
